module.exports = __webpack_public_path__ + "img/newyear_header.df3c768c.jpg";